import { animate, animation, style } from '@angular/animations';

export const slideInHorizontal = animation(
  [
    style({
      opacity: '{{ startOpacity }}',
      transform: 'translateX({{ translateX }})',
    }),
    animate(
      '{{ duration }}ms {{ delay }}ms {{ easing }}',
      style({
        opacity: '{{ finishOpacity }}',
        transform: 'translateX(0)',
      }),
    ),
  ],
  {
    params: {
      duration: '200',
      delay: '0',
      easing: 'ease-in',
      translateX: '10%', // can be any unit
      startOpacity: 0,
      finishOpacity: 1,
    },
  },
);

export const slideInVertical = animation(
  [
    style({
      opacity: '{{ startOpacity }}',
      transform: 'translateY({{ translateY }})',
    }),
    animate(
      '{{ duration }}ms {{ delay }}ms {{ easing }}',
      style({
        opacity: '{{ finishOpacity }}',
        transform: 'translateY(0)',
      }),
    ),
  ],
  {
    params: {
      duration: '200',
      delay: '0',
      easing: 'ease-in',
      translateY: '10%', // can be any unit
      startOpacity: 0,
      finishOpacity: 1,
    },
  },
);
